import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropertyWalkThroughFormSteps from './PropertyWalkThroughFormSteps';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setPropertyWalkThroughFormStep } from '../../store/actions/propertyWalkThroughForm';
import { selectSuiteById } from '../../store/selectors/suites';
import { selectPropertyWalkThroughFormData } from '../../store/selectors/propertyWalkThroughForm';

class PropertyWalkThroughForm extends Component {
  render() {
    return (
      <PropertyWalkThroughFormSteps {...this.props} />
    );
  }
}

const mapStateToProps = state => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  return {
    propertyWalkThroughFormData,
    user:selectAuthenticatedUser(state),
    suite:selectSuiteById(state, propertyWalkThroughFormData.suiteId)
  }
 
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetPropertyWalkThroughFormStep:setPropertyWalkThroughFormStep
  
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyWalkThroughForm);
